import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  label: {
    minWidth: 'auto',
    maxWidth: 'inherit',
    padding: 0,
    marginRight: '13%',
    fontWeight: 500,
    fontSize: 14,
  },
  title: {
    flexGrow: 1,
    fontSize: 14,
    margin: theme.spacing(1),
  },
  gridPaper: {
    height: '100%',
  },
  tabsPaper: {
    boxShadow: theme.shadows[0],
    backgroundColor: 'transparent',
  },
  tabsPanel: {
    width: '50%',
  },
  tabBox: {
    backgroundColor: '#ffffff',
    marginTop: theme.spacing(2.5),
  },
  row: {
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3.5),
  },
  textLabel: {
    fontSize: 14,
    margin: theme.spacing(0, 3.5, 0, 0),
  },
  desc: {
    width: 'calc(100% - 260px)',
    borderBottom: '1px solid #E0E0E0',
    padding: 5,
  },
}));
